/**
 * 从浏览器 Cookie 恢复「7 天免登录」保存的会话到 Vuex 与 localStorage/sessionStorage。
 * 须在 Vue.use(VueCookies) 之后调用（见 main.js），避免早于插件初始化读 Cookie。
 */
export function hydrateRememberMeFromCookie(store, VueCookies) {
  if (!store || !VueCookies || typeof VueCookies.get !== "function") {
    return;
  }
  const obj = VueCookies.get("REMEMBER_ME");
  if (!obj || !obj.token || !obj.user) {
    return;
  }
  store.commit("auth/setUser", obj.user);
  store.commit("auth/setToken", obj.token);
  store.commit("auth/setSessionUser", obj.user);
  store.commit("auth/setSessionToken", obj.token);
  // 保持与旧逻辑一致：REMEMBER_ME 存在时自动回填 congress/token/user Cookie
  // 这样即使手动删除了 congress，刷新后也会自动恢复。
  const host = window.location.hostname || "";
  const isIpv4 = /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
  let domain = "";
  if (host && host !== "localhost" && !isIpv4 && host.indexOf(".") !== -1) {
    const parts = host.split(".");
    domain = parts.length <= 2 ? `.${host}` : `.${parts.slice(-2).join(".")}`;
  }
  const domainPart = domain ? `; domain=${domain}` : "";
  const maxAge = 7 * 24 * 60 * 60;
  // 清理旧 congress，避免 host/domain 双份
  document.cookie = `congress=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  if (domain) {
    document.cookie = `congress=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
  document.cookie = `congress=${encodeURIComponent(
    obj.token
  )}; path=/${domainPart}; max-age=${maxAge}; SameSite=Lax`;
  document.cookie = `token=${encodeURIComponent(
    obj.token
  )}; path=/${domainPart}; max-age=${maxAge}; SameSite=Lax`;
  document.cookie = `user=${encodeURIComponent(
    JSON.stringify(obj.user || {})
  )}; path=/${domainPart}; max-age=${maxAge}; SameSite=Lax`;
}
